import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";

export const PasswordDialog = ({ admin }) => {
  const [open, setOpen] = useState(false);
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (pwd.length < 6) return toast.error("Au moins 6 caractères");
    if (pwd !== confirm) return toast.error("Les mots de passe ne correspondent pas");
    setSaving(true);
    try {
      await api.put(`/admins/${admin.id}/password`, { password: pwd });
      toast.success(`Mot de passe de ${admin.email} modifié`);
      setOpen(false); setPwd(""); setConfirm("");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Échec de la modification");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="icon" variant="ghost" title="Modifier le mot de passe" data-testid={`change-password-${admin.id}`}>
          <KeyRound className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent data-testid="password-dialog">
        <DialogHeader>
          <DialogTitle>Modifier le mot de passe</DialogTitle>
          <DialogDescription>{admin.email}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5">
            <Label className="text-xs">Nouveau mot de passe</Label>
            <Input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} data-testid="new-password-input" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs">Confirmer</Label>
            <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="confirm-password-input" />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={save} disabled={saving} data-testid="save-password-button">
            {saving && <Loader2 className="mr-1 h-4 w-4 animate-spin" />} Enregistrer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
